import { useEffect, useState } from "react";
import useElementSize from "src/hooks/useElementSize";
import useScrollPosition from "src/hooks/useScrollPosition";
import useWindowSize from "src/hooks/useWindowSize";

interface LayoutSidebarProps {
	children?: any;
	span?: number;
	className?: string;
}

const LayoutSidebar = ({ children, span, className }: LayoutSidebarProps) => {
	const { ref, size, getSize } = useElementSize();
	const maxHeight = window.innerHeight - size?.top - 32;
	const y = useScrollPosition();
	const { isPhone } = useWindowSize();
	const [isSticky, setIsSticky] = useState(false);

	useEffect(() => {
		if (ref?.current) {
			const _size = getSize(ref);
			setIsSticky(y + 32 > _size.y ? true : false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [y]);

	if (isPhone) {
		return (
			<div
				{...{ ref }}
				className={`flex-1 flex flex-col gap-8 ${className || ""}`}
			>
				{children}
			</div>
		);
	}

	return (
		<div
			{...{ ref }}
			className={`col-span-${span} flex-1 flex flex-col gap-8 ${
				className || ""
			}`}
		>
			<div
				style={
					isSticky
						? {
								top: 32,
								bottom: 32,
								left: size.x,
								width: size.width,
						  }
						: {
								maxHeight,
						  }
				}
				className={`${
					isSticky ? "fixed" : ""
				} flex-1 flex flex-col gap-8`}
			>
				{children}
			</div>
		</div>
	);
};

LayoutSidebar.defaultProps = {
	span: 3,
};

export default LayoutSidebar;
